import gql from 'graphql-tag';

export default gql`
mutation deleteGroupAndSubGroups($group_id: Int!, $name: String!) {
  deleteGroup(object: {group_id: $group_id, name: $name}) {
    deletedGroups
  }
}
`;
